var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-partition',{attrs:{"title":"账单信息"}},[_c('Table',{ref:"mt",attrs:{"columns":_vm.columns,"data":_vm.list,"height":"350","loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }